import { useState } from "react";

import { Modal } from "../components/Modal";

export type SealButtonProps = {
  sealed: boolean;
  canSeal: boolean;
  canUnseal: boolean;
  onSeal(): void;
  onUnseal(): void;
};

/**
 * Sealing can't be drawn through, so it asks first; unsealing only ever
 * reopens what was already there, so owner and teacher can do it without
 * a confirmation dialog.
 */
export const SealButton = ({
  sealed,
  canSeal,
  canUnseal,
  onSeal,
  onUnseal,
}: SealButtonProps) => {
  const [asking, setAsking] = useState(false);

  if (sealed) {
    return canUnseal ? (
      <button type="button" onClick={onUnseal}>
        마감 풀기
      </button>
    ) : null;
  }
  if (!canSeal) {
    return null;
  }
  return (
    <>
      <button type="button" onClick={() => setAsking(true)}>
        마감하기
      </button>
      {asking && (
        <Modal
          title="마감하기"
          primaryLabel="마감"
          secondaryLabel="더 할래요"
          danger
          onCancel={() => setAsking(false)}
          onPrimary={() => {
            setAsking(false);
            onSeal();
          }}
        >
          {/* 실수로 누르는 아이가 많아서 한 번 더 확인한다. */}
          <div className="canvaschool-modal-danger-box">
            <p>마감하면 이제 고칠 수 없어요. 마감할까요?</p>
          </div>
        </Modal>
      )}
    </>
  );
};
